import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import { control, iconButton } from '../../styles/mixins';

const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 40;
  width: calc(100% + 8rem);
  margin-left: -4rem;
  padding: 0 4rem;
  background-color: var(--surface);
  border-bottom: 1px solid var(--border);

  @media (max-width: 1080px) {
    width: calc(100% + 4rem);
    margin-left: -2rem;
    padding: 0 2rem;
  }
`;

const Header = styled.header`
  max-width: var(--content-max);
  min-height: var(--header-h);
  display: flex;
  align-items: center;
  gap: 2rem;
  margin: 0 auto;

  @media (max-width: 980px) {
    justify-content: space-between;
    gap: 1rem;
  }
`;

const LogoContainer = styled.img`
  width: 10rem;
  cursor: pointer;
  flex: none;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: none;
`;

const NavButton = styled.button`
  height: 3.8rem;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0 1.4rem;
  border: none;
  border-radius: var(--r-btn);
  font-size: 1.45rem;
  font-weight: 600;
  background-color: ${({ active }) =>
    active ? 'var(--surface-2)' : 'transparent'};
  color: ${({ active }) => (active ? 'var(--ink)' : 'var(--ink-soft)')};
  transition: background-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard);

  :hover {
    background-color: var(--surface-2);
    color: var(--ink);
  }
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 42rem;
  position: relative;

  > svg {
    position: absolute;
    left: 1.5rem;
    color: var(--ink-faint);
    pointer-events: none;
  }
`;

const SearchInput = styled.input`
  ${control}
  width: 100%;
  height: 4rem;
  border-radius: var(--r-btn);
  background-color: var(--surface-2);
  padding-left: 4.2rem;
  padding-right: 1.6rem;
  font-size: 1.4rem;

  :focus {
    background-color: var(--surface);
  }
`;

const MobileSearch = styled.div`
  max-width: var(--content-max);
  margin: 0 auto;
  padding-bottom: 1.4rem;

  > div {
    max-width: none;
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex: none;
  margin-left: auto;
`;

const IconButton = styled.button`
  ${iconButton}
  height: 3.8rem;
`;

const Badge = styled.span`
  position: absolute;
  top: 0.4rem;
  right: 0.3rem;
  min-width: 1.7rem;
  height: 1.7rem;
  padding: 0 0.4rem;
  border-radius: var(--r-pill);
  background-color: var(--rosa);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid var(--surface);
`;

const Link = styled(RouterLink)`
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--ink-soft);
  padding: 0 1rem;
  white-space: nowrap;
  transition: color var(--dur-fast) var(--ease-standard);

  :hover {
    color: var(--ink);
  }
`;

const UserLink = styled(RouterLink)`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.4rem 1.4rem 0.4rem 0.4rem;
  border-radius: var(--r-pill);
  color: var(--ink-soft);
  transition: background-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard);

  span {
    font-size: 1.35rem;
    font-weight: 600;
    white-space: nowrap;
  }

  :hover {
    background-color: var(--surface-2);
    color: var(--ink);
  }
`;

const UserImage = styled.img`
  width: 3.4rem;
  height: 3.4rem;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--border);
`;

export {
  Actions,
  Badge,
  Container,
  Header,
  IconButton,
  InputContainer,
  Link,
  LogoContainer,
  MobileSearch,
  Nav,
  NavButton,
  SearchInput,
  UserImage,
  UserLink,
};
